module.exports = __webpack_public_path__ + "media/images/step-3-2b96f0ddc08e685fb3f475303e3f450a.png";